// src/app/core/customer/customer-config.service.ts

import { Injectable } from '@angular/core';
import { CUSTOMER_CONFIG } from './customer.config';
import { CustomerConfig, CustomerFeatureKey } from './customer-config.model';

@Injectable({ providedIn: 'root' })
export class CustomerConfigService {
  readonly config: CustomerConfig = CUSTOMER_CONFIG;

  get customerId(): string {
    return this.config.customerId;
  }

  get customerName(): string {
    return this.config.customerName;
  }

  get overrides() {
    return this.config.overrides ?? {};
  }

  hasFeature(feature: CustomerFeatureKey): boolean {
    return this.config.enabledFeatures.includes(feature);
  }

  getLabel(key: string, fallback: string): string {
    return this.overrides.labels?.[key] ?? fallback;
  }

  getLandingOverrides() {
    return this.overrides.landing ?? {};
  }

  getTransferOverrides() {
    return this.overrides.transfer ?? {};
  }
  getReceiveOverrides() {
    return this.overrides.receive ?? {};
  }

  getShippingOverrides() {
    return this.overrides.shipping ?? {};
  }

  getReferenceDocumentOverrides() {
    return this.overrides.referenceDocuments ?? {};
  }

  getEndpointOverrides() {
    return this.overrides.endpoints ?? {};
  }

  getFishingLandingOverrides() {
    return this.overrides.fishingLanding ?? {};
  }
}
